import { render } from "./flag_Icon.vue?vue&type=template&id=7a0bf1fc"
import script from "./flag_Icon.vue?vue&type=script&lang=js"
export * from "./flag_Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__